module.exports = __webpack_public_path__ + "img/ic-map-filter-off.7adacac4.svg";